module.exports = __webpack_public_path__ + "static/media/miles-verified.e09e3d9f.svg";